import postRequest from '../../../../../../postRequest';

/**
 * Bulk upload a single line attribute.
 *
 * @param {number} SiteId Site Id
 * @param {number} SourceId Source Id
 * @param {number} AttributeDefKeyId Attribute Id
 * @param {number} LanguageId Language Id
 * @param {file} File Either a csv or excel file
*/
export default function postSingleLineAttributesPluId({
  SiteId,
  SourceId,
  AttributeDefKeyId,
  LanguageId,
  File,
}) {
  const endpoint = `/oc-product-bulkapi/v1/bulk-process/single-line-attributes/plu-id/${SourceId}`;

  const body = new FormData();
  body.append('SiteId', SiteId);
  body.append('AttributeDefKeyId', AttributeDefKeyId);
  body.append('LanguageId', LanguageId);
  body.append('File', File);

  return new Promise((resolve, reject) => {
    postRequest(
      endpoint,
      body,
      'Single Line Attributes PLU Ids',
      'Started : Single Line Attributes : PLU (Update)',
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}
